export const USER_LOGIN_COOKIE = "loginUserRemember";
export const RESET_PRODUCT_VIEWS = "resetProductViews";
export const USER_JUST_LOGGED_IN = "userJustLoggedIn";
export const USER_JUST_LOGGED_OUT = "userJustLoggedOut";
export const BASE_URL_WEB_APP = "http://138.68.242.123";

/** API base URL. Empty = same origin (use proxy in dev). Set REACT_APP_API_BASE_URL for production if API is on another host (e.g. http://138.68.242.123:5001). */
export const API_BASE_URL = "http://138.68.242.123:3002";